export type Language = 'en' | 'de'

export const t = (key: string, lang: Language): string => {
  return translations[key]?.[lang] ?? translations[key]?.['en'] ?? key
}

const translations: Record<string, Record<string, string>> = {
  // NAV
  'nav.about':       { en: 'About Me',     de: 'Über mich' },
  'nav.skills':      { en: 'Skills',        de: 'Fähigkeiten' },
  'nav.experience':  { en: 'Experience',    de: 'Erfahrung' },
  'nav.education':   { en: 'Education',     de: 'Ausbildung' },
  'nav.projects':    { en: 'Projects',      de: 'Projekte' },
  'nav.certificates':{ en: 'Certificates',  de: 'Zertifikate' },
  'nav.contact':     { en: 'Contact',       de: 'Kontakt' },

  // ABOUT
  'about.greeting':  { en: 'Welcome Folks', de: 'Herzlich Willkommen' },
  'about.intro':     { en: "Let me introduce you a little about me :)", de: 'Lass mich dir ein bisschen über mich erzählen :)' },
  'about.iam':       { en: "I'm", de: 'Ich bin' },
  'about.role':      { en: 'A Software Engineer', de: 'Ein Software-Ingenieur' },
  'about.years':     { en: 'with 4 Years of Development Experience!', de: 'mit 4 Jahren Entwicklungserfahrung!' },
  'about.resumeEN':  { en: 'Resume (English)', de: 'Lebenslauf (Englisch)' },
  'about.resumeDE':  { en: 'Resume (German)',  de: 'Lebenslauf (Deutsch)' },

  // SKILLS
  'skills.label':    { en: 'What I Know',   de: 'Was ich kann' },
  'skills.title':    { en: 'My Tech Stack', de: 'Mein Tech-Stack' },
  'skills.desc':     { en: 'Technologies and tools I work with to build amazing products.', de: 'Technologien und Tools, mit denen ich tolle Produkte baue.' },

  // EXPERIENCE
  'exp.label':       { en: 'Where I Worked',       de: 'Wo ich gearbeitet habe' },
  'exp.title':       { en: 'Work Experience',       de: 'Berufserfahrung' },
  'exp.desc':        { en: 'My professional journey and the companies I have worked with.', de: 'Mein beruflicher Werdegang und die Unternehmen, für die ich gearbeitet habe.' },
  'exp.present':     { en: 'Present',               de: 'Aktuell' },

  // EDUCATION
  'edu.label':       { en: 'Where I Studied',   de: 'Wo ich studiert habe' },
  'edu.title':       { en: 'Education',          de: 'Ausbildung' },
  'edu.desc':        { en: 'My academic background and qualifications.', de: 'Mein akademischer Hintergrund und meine Qualifikationen.' },

  // PROJECTS
  'proj.label':      { en: 'What I Built',   de: 'Was ich gebaut habe' },
  'proj.title':      { en: 'Projects',        de: 'Projekte' },
  'proj.desc':       { en: 'A selection of projects I have worked on.', de: 'Eine Auswahl der Projekte, an denen ich gearbeitet habe.' },
  'proj.demo':       { en: 'Live Demo',       de: 'Live-Demo' },
  'proj.code':       { en: 'View Code',       de: 'Code ansehen' },

  // CERTIFICATES
  'cert.label':      { en: 'Achievements',    de: 'Errungenschaften' },
  'cert.title':      { en: 'Certificates',    de: 'Zertifikate' },
  'cert.desc':       { en: 'Professional certifications and courses completed.', de: 'Abgeschlossene Zertifizierungen und Kurse.' },
  'cert.view':       { en: 'View Certificate', de: 'Zertifikat ansehen' },

  // CONTACT
  'contact.label':   { en: 'Get In Touch',    de: 'Kontakt aufnehmen' },
  'contact.title':   { en: 'Contact Me',      de: 'Kontaktiere mich' },
  'contact.desc':    { en: "Have a project in mind or just want to say hello? I'd love to hear from you!", de: 'Haben Sie ein Projekt im Sinn oder möchten Sie einfach Hallo sagen? Ich freue mich von Ihnen zu hören!' },
  'contact.name':    { en: 'Your Name',       de: 'Ihr Name' },
  'contact.email':   { en: 'Your Email',      de: 'Ihre E-Mail' },
  'contact.subject': { en: 'Subject',         de: 'Betreff' },
  'contact.message': { en: 'Your Message',    de: 'Ihre Nachricht' },
  'contact.send':    { en: 'Send Message',    de: 'Nachricht senden' },
  'contact.sending': { en: 'Sending...',      de: 'Wird gesendet...' },
  'contact.success': { en: 'Message sent! I will get back to you soon.', de: 'Nachricht gesendet! Ich melde mich bald bei Ihnen.' },
  'contact.error':   { en: 'Something went wrong. Please try again.', de: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.' },
}
